import { getSpace } from '../../../foundation/theme/space.utils';
import { getFontSize } from '../../../foundation/theme/typography.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// Constants.
// -----------------------------------------------------------------------------
export const BASE_SELECT_DEFAULT_MATCH_ORDER = false;
// styles.
export const BASE_SELECT_DEFAULT_MODE = 'light';
export const BASE_SELECT_DEFAULT_SIZE = 's';
export const BASE_SELECT_DEFAULT_ROLE = 'none';
export const MAPPING_MODE = {
    // Dark.
    dark: {
        clearIndicator: {
            borderRight: tokens.colors.midnight[700].value,
            color: tokens.colors.midnight[300].value
        },
        control: {
            background: tokens.colors.black[100].value,
            border: tokens.colors.midnight[700].value,
            color: tokens.colors.midnight[200].value,
            focus: {
                border: tokens.colors.midnight[200].value,
                shadow: tokens.colors.midnight[150].value
            },
            hover: {
                border: tokens.colors.midnight[500].value
            }
        },
        menu: {
            border: tokens.colors.midnight[700].value
        },
        multi: {
            remove: {
                color: tokens.colors.midnight[300].value,
                hoverColor: tokens.colors.midnight[300].value
            },
            value: {
                background: tokens.colors.midnight[300].value,
                border: tokens.colors.midnight[300].value
            }
        },
        option: {
            focus: {
                background: tokens.colors.midnight[300].value
            },
            selected: {
                background: '#00ccaa',
                color: tokens.colors.navy[800].value
            }
        },
        placeholder: tokens.colors.midnight[300].value
    },
    // Light.
    light: {
        clearIndicator: {
            borderRight: tokens.colors.midnight[200].value,
            color: tokens.colors.midnight[800].value
        },
        control: {
            background: tokens.colors.white[100].value,
            border: tokens.colors.midnight[200].value,
            color: tokens.colors.midnight[800].value,
            focus: {
                border: tokens.colors.midnight[850].value,
                shadow: tokens.colors.midnight[150].value
            },
            hover: {
                border: tokens.colors.midnight[400].value
            }
        },
        menu: {
            border: tokens.colors.midnight[200].value
        },
        multi: {
            remove: {
                color: tokens.colors.black[100].value,
                hoverColor: tokens.colors.midnight[800].value
            },
            value: {
                background: tokens.colors.white[100].value,
                border: tokens.colors.midnight[200].value
            }
        },
        option: {
            focus: {
                background: tokens.colors.midnight[150].value
            },
            selected: {
                background: '#00ccaa',
                color: tokens.colors.navy[800].value
            }
        },
        placeholder: tokens.colors.midnight[300].value
    }
};
export const MAPPING_SCALE = {
    // 's'.
    s: {
        control: {
            fontSize: getFontSize('s'),
            minHeight: '3.5rem'
        },
        dropdownIndicator: {
            paddingBottom: getSpace('2xl'),
            paddingLeft: getSpace('s'),
            paddingRight: getSpace('2xl'),
            paddingTop: getSpace('m')
        },
        multiLabel: {
            paddingBottom: getSpace('s'),
            paddingLeft: getSpace('l'),
            paddingRight: getSpace('s'),
            paddingTop: getSpace('s')
        },
        value: {
            paddingLeft: '1.25rem'
        }
    },
    // 'xs'.
    xs: {
        control: {
            fontSize: getFontSize('s'),
            minHeight: '2.5rem'
        },
        dropdownIndicator: {
            paddingBottom: getSpace('m'),
            paddingLeft: getSpace('s'),
            paddingRight: getSpace('2xl'),
            paddingTop: getSpace('m')
        },
        multiLabel: {
            paddingBottom: getSpace('xs'),
            paddingLeft: getSpace('s'),
            paddingRight: getSpace('s'),
            paddingTop: getSpace('xs')
        },
        value: {
            paddingLeft: getSpace('m')
        }
    }
};
//# sourceMappingURL=BaseSelect.constants.js.map